import React from 'react'
import { Link, useStaticQuery, graphql } from 'gatsby'
import starIcon from '../../assets/images/star-icon.png'

const RecentProjects = () => {
  const { projects } = useStaticQuery(
    graphql`
      query {
        projects: allContentfulCaseStudies(
          limit: 6
          sort: { order: DESC, fields: createdAt }
        ) {
          edges {
            node {
              slug
              title
              featured {
                fluid(maxWidth: 750) {
                  srcWebp
                }
              }
              service {
                title
              }
            }
          }
        }
      }
    `
  )

  if (!projects) {
    return null
  }

  return (
    <section className="projects-area bg-color pt-100 pb-70">
      <div className="container">
        <div className="section-title">
          <span className="sub-title">
            <img src={starIcon} alt="project" /> Recent Projects
          </span>
          <h2>Check Some Of Our Recent Work</h2>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna.
          </p>
        </div>

        <div className="row">
          {projects.edges.map((project, index) => {
            return (
              <div key={index} className="col-lg-4 col-md-6">
                <div className="single-projects-box">
                  <div className="image">
                    <img src={project.node.featured.fluid.srcWebp} alt="" />
                    <Link
                      className="link-btn"
                      to={`/case-studies/` + project.node.slug}
                      aria-label="View detail"
                    >
                      <i className="bx bx-plus"></i>
                    </Link>
                  </div>

                  <div className="content">
                    <h3>
                      <Link to={`/case-studies/` + project.node.slug}>
                        {project.node.title}
                      </Link>
                    </h3>
                    <span>{project.node.service.title}</span>
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}

export default RecentProjects
